import { jsonMember, jsonObject } from 'typedjson';
import { Nillable } from '@web/utils';
import { AdminBoxSaleApproveStatusOrdersResponse } from './admin-box-sale-approve-status-orders.response';

@jsonObject
export class AdminBoxSaleApproveStatusResponse {
  @jsonMember(Boolean)
  public readonly isAvailable!: boolean;

  @jsonMember(Boolean)
  public readonly questionnairesWillBeGenerated!: boolean;

  @jsonMember(String)
  public readonly errorMessage?: Nillable<string>;

  @jsonMember(AdminBoxSaleApproveStatusOrdersResponse)
  public readonly orders?: Nillable<AdminBoxSaleApproveStatusOrdersResponse>;
}
